import { Box, FormSelect, FormText, IconButton } from "@husqvarna/ui-core";
import { useIntl } from "react-intl";

export type ServiceProps = {
  selectRef?: React.RefObject<HTMLSelectElement>;
};

const Service = ({
  selectRef,
}: ServiceProps) => {
  const intl = useIntl(); 
  return (
    <Box mt={12}>
      <Box container alignItems="center" className="tcsp-form-container">
        <Box flexGrow={1}>
          <FormSelect 
            forwardedRef={selectRef} 
            options={[{ label: "None", disabled: true}, { label: "Service 1", value: "service1" }, { label: "Service 2", value: "service2" }]} 
            label={intl.formatMessage({
            id: "projects.services.serviceSelect",
            defaultMessage: "Choose service",
          })} />
        </Box>
        <IconButton icon="trash" size="Medium" ml={2} />
      </Box>
      <Box mt={4} className="tcsp-form-container">
        <FormText label={intl.formatMessage({
          id: "projects.services.serviceCost",
          defaultMessage: "Cost per year",
        })} />
      </Box>
    </Box>
  );
};

export default Service;